module.exports = __webpack_public_path__ + "img/failed-icon.683cf26e.svg";